import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { debounce } from 'vscode/vscode/vs/base/common/decorators';
import { Event } from 'vscode/vscode/vs/base/common/event';
import { Disposable, MutableDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IAccessibilityService } from 'vscode/vscode/vs/platform/accessibility/common/accessibility.service';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { ITerminalLogService } from 'vscode/vscode/vs/platform/terminal/common/terminal.service';

let TextAreaSyncAddon = class TextAreaSyncAddon extends Disposable {
    activate(terminal) {
        this._terminal = terminal;
        this._refreshListeners();
    }
    constructor(_capabilities, _accessibilityService, _configurationService, _logService) {
        super();
        this._capabilities = _capabilities;
        this._accessibilityService = _accessibilityService;
        this._configurationService = _configurationService;
        this._logService = _logService;
        this._listeners = this._register(( new MutableDisposable()));
        this._register(Event.runAndSubscribe(Event.any(this._capabilities.onDidAddCapability, this._capabilities.onDidRemoveCapability, this._accessibilityService.onDidChangeScreenReaderOptimized), () => {
            this._refreshListeners();
        }));
    }
    _refreshListeners() {
        const commandDetection = this._capabilities.get(2 );
        if (this._shouldBeActive() && commandDetection) {
            if (!this._listeners.value) {
                const textarea = this._terminal?.textarea;
                if (textarea) {
                    this._listeners.value = Event.runAndSubscribe(commandDetection.promptInputModel.onDidChangeInput, () => this._sync(textarea));
                }
            }
        }
        else {
            this._listeners.clear();
        }
    }
    _shouldBeActive() {
        return this._accessibilityService.isScreenReaderOptimized() || this._configurationService.getValue("terminal.integrated.developer.devMode" );
    }
    _sync(textArea) {
        const commandCapability = this._capabilities.get(2 );
        if (!commandCapability) {
            return;
        }
        textArea.value = commandCapability.promptInputModel.value;
        textArea.selectionStart = commandCapability.promptInputModel.cursorIndex;
        textArea.selectionEnd = commandCapability.promptInputModel.cursorIndex;
        this._logService.debug(`TextAreaSyncAddon#sync: text changed to "${textArea.value}"`);
    }
};
TextAreaSyncAddon.__decorator = ( __decorate([
    debounce(50)
], TextAreaSyncAddon.prototype, "_sync", null));
TextAreaSyncAddon = ( __decorate([
    ( __param(1, IAccessibilityService)),
    ( __param(2, IConfigurationService)),
    ( __param(3, ITerminalLogService))
], TextAreaSyncAddon));

export { TextAreaSyncAddon };
